/**
 * Utilities for handling Open Food Facts product images
 */

/**
 * Converts an EAN barcode to the Open Food Facts image URL structure
 * Based on: https://openfoodfacts.github.io/openfoodfacts-server/api/how-to-download-images/
 * 
 * @param ean - The EAN barcode (13 digits)
 * @param imageType - Type of image (unused, kept for compatibility)
 * @param language - Language code (unused, kept for compatibility)
 * @param size - Image size ('100', '200', '400', 'full')
 * @returns Image URL or null if invalid barcode
 */
export const getOpenFoodFactsImageUrl = (
  ean: string, 
  imageType: 'front' | 'ingredients' | 'nutrition' | 'packaging' = 'front',
  language: 'en' | 'de' = 'en',
  size: '100' | '200' | '400' | 'full' = '200'
): string | null => {
  if (!ean || ean.length < 8) {
    return null;
  }

  // Pad to 13 digits
  const paddedEan = ean.padStart(13, '0');
  
  // Create folder structure: 4 levels total
  // First 3 levels are 3 digits each, last level is remaining digits
  const first = paddedEan.slice(0, 3);
  const second = paddedEan.slice(3, 6);
  const third = paddedEan.slice(6, 9);
  const fourth = paddedEan.slice(9);
  
  const folderPath = `${first}/${second}/${third}/${fourth}`;
  
  // Use numbered image format which is most commonly available
  const filename = `1.${size}.jpg`;
  
  return `https://images.openfoodfacts.org/images/products/${folderPath}/${filename}`;
};

